/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class KubernetesClusterSyncUpdateRequest extends models.ProgressDetailsForKubernetesAgentSyncStatus {
    getFixupPrototypeFunction() { return KubernetesClusterSyncUpdateRequest.fixupPrototype; }

    static newInstance(model: Partial<KubernetesClusterSyncUpdateRequest>): KubernetesClusterSyncUpdateRequest {
        let obj = Object.assign(new KubernetesClusterSyncUpdateRequest(), model);
        KubernetesClusterSyncUpdateRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<KubernetesClusterSyncUpdateRequest>): KubernetesClusterSyncUpdateRequest {
        if (!model) return null;
        return KubernetesClusterSyncUpdateRequest.newInstance(<KubernetesClusterSyncUpdateRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: KubernetesClusterSyncUpdateRequest) {
        if (!obj) return;

        models.KubernetesClusterSyncUpdateRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: KubernetesClusterSyncUpdateRequest): boolean {
        if (models.ProgressDetailsForKubernetesAgentSyncStatus.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, KubernetesClusterSyncUpdateRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Kubernetes Sync Status Types
     */
    syncer_type: models.KubernetesSyncStatusTypes;

}
